var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-wrapper",attrs:{"slot":""},slot:"default"},[_c('input',{attrs:{"id":"checker","type":"checkbox"},on:{"change":_vm.toggle}}),_c('label',{staticClass:"switch",attrs:{"for":"checker"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }